import { gql } from 'graphql-request';

export const GET_WORK_ORDER_PLAN_TYPES_QUERY = gql`
  query workOrderPlanTypes {
    workOrderPlanTypes {
      displayName
      id
      isDefault
      ownerID
      progressState
    }
  }
`;

export const GET_WORK_ORDER_PLAN_TYPE_QUERY = gql`
  query workOrderPlanType($id: ID!) {
    workOrderPlanType(id: $id) {
      displayName
      id
      isDefault
      ownerID
      progressState
    }
  }
`;
